import { styled } from '@mui/system';
import { BoxPanel } from 'screens/styles';
import { Button } from '@mui/material';

const SuccessRoot = styled('div', {target: 'SuccessRoot'})(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '600px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    flexBasis: '100%',
  },
}));

const StyledShadowBox = styled(BoxPanel,{target: 'StyledShadowBox'})(({ theme }) => ({
  background: '#fff',
  padding: theme.spacing(4,6,5,6)
}));

const Confirmation = styled('span')(({ theme }) => ({
  marginLeft: theme.spacing(1),
  fontSize: '0.75rem',
  color: theme.vars.palette.secondary.textIconColor,
  textAlign: 'center',
  whiteSpace: 'pre-wrap'
}));

const CustomButton = styled(Button)(({ theme }) => ({
  alignSelf: 'center',
  border: `1px solid ${theme.vars.palette.primary.main}`,
  height: theme.spacing(5),
  overflow: 'hidden',
  display: 'block',
  width: 'auto',
  maxWidth: '500px',
  textOverflow: 'ellipsis',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '95vw',
  },
}));

const PrimaryButton = styled(CustomButton)(({ theme }) => ({
  fontSize: '1rem',
  '&:hover':{
    background: 'var(--mui-palette-primary-main)'
  },
}));

const WhiteButton = styled(CustomButton)(({theme}) => ({
  marginTop: '24px',
  fontSize: '1rem',
  padding: theme.spacing(0,4),
  '&:hover':{
    boxShadow: `0px 2px 8px rgb(${theme.vars.palette.primary.mainChannel} / 0.25)`,
    background: '#fff'
  },
}));

const TextButton = styled(CustomButton)(({theme}) => ({
  border: 'none',
  marginTop: theme.spacing(3.5),
  paddingRight: '12px',
  paddingLeft: '12px',
  fontSize: '0.875rem !important',
  '&:hover':{
    boxShadow: `0px 2px 8px rgb(${theme.vars.palette.primary.mainChannel} / 0.25)`,
    background: '#fff'
  }
}));

export {
  SuccessRoot,
  StyledShadowBox,
  Confirmation,
  CustomButton,
  PrimaryButton,
  WhiteButton,
  TextButton
}